import * as marietta3d from '../..';
import * as marietta from '../../../marietta';

/*
* グローバル変数
*
* ゼロとみなす値
*/
export const ZERO_NUM = 0.1;
export const ALMOST_ZERO = 0.0001;

/*
* 点が領域に含まれるか。
*
* 与えられた点からの半直線を考え、半直線と多角形の交差する数が奇数なら、点は内側にある
* 戻り値：
*
* 0 = 点は多角形の線上。
* 1 = 点は多角形の内側
* 2 = 点は多角形の外側
*/
export const RC_INCLUDE = {
  ONLINE: 0,
  INSIDE: 1,
  OUTSIDE: 2,
};
/*
* 線分と点の関係を求める
*
* Return Code -3:直線の始終点が近過ぎて計算不可能
* -2:始点から終点向かう直線の左側にある
* -1:始点から終点向かう直線の右側にある
*  0:直線上にある
*  1:直線の始点上にある
*  2:直線の終点上にある
*  3:直線の始点の外にある
*  4:直線の終点の外にある
*
*  ◎TOLが0.0の場合,default値2.0の値が入る
*/
export const RC_POEZ2 = {
  IMPOSIBLE_SHORT: -3,
  LEFTSIDE_OF_START: -2,
  RIGHTSIDE_OF_END: -1,
  ON_EDGE: 0,
  ON_START: 1,
  ON_END: 2,
  OUTSIDE_START: 3,
  OUTSIDE_END: 4,
};

/*
* ２つの領域の重なり判定
*
* Return Code 0:領域が離れている
* 1:同一領域
* 2:重なりあり
* 3:接している(外接(点接触を含む))
* 4:ＢがＡに含まれる
* 5:ＢがＡに含まれる(内接(点接触を含む))
* 6:ＡがＢに含まれる
* 7:ＡがＢに含まれる(内接(点接触を含む))
*/
export const RC_INCLP = {
  AWAY: 0,
  SAME: 1,
  OVERLAP: 2,
  OUTSIDE_CONTACT: 3,
  INCLUDE_BY_A: 4,
  INCLUDE_BY_A_CONTACT: 5,
  INCLUDE_BY_B: 6,
  INCLUDE_BY_B_CONTACT: 7,
};

/*
* 幾何計算ライブラリ
*/
export class Geometry {
  /*
    * plg1の区間属性をplg2にコピーする
    *
    */
  public static CopyNonVisible(plg1: marietta3d.AutoGen.utils.RoomPointArray, plg2: marietta3d.AutoGen.utils.RoomPointArray) {
    const pcnt1 = plg1.length;
    const plg2Arr = plg2;
    for (let i = 0; i < pcnt1; i += 1) {
      const ln1 = plg1.GetLine(i);
      const { flag } = ln1.s;
      const pcnt2 = plg2.length;
      for (let i2 = 0; i2 < pcnt2; i2 += 1) {
        const ln2 = plg2.GetLine(i2);
        const len = ln1.IsOverlapLine(ln2);
        if (len > ALMOST_ZERO) {
          /* 重なりがある */
          const t1 = ln2.LocationPtOnLine(ln1.s); /* k1-k2に対するp1の位置 */
          const t2 = ln2.LocationPtOnLine(ln1.e); /* k1-k2に対するp2の位置 */
          const attr = plg2[i2].flag;
          /* p1 --- p2 flag (plg1属性) */
          /* k1 ### k2 attr (plg2属性) */
          if (t1 < t2) {
            if (t1 <= 0) { /* p1 --- k1 --- k2 */
              /* k1-k2 は始点から非表示 */
              plg2Arr[i2].flag = flag;
              if (t2 >= 1.0) {
                /* k1-k2 は終点まで非表示    // p1 --- k1 --- k2 --- p2 */
              } else {
                /* k1-k2 の間にp2を追加し、全面とする。p1 --- k1 --- p2 ### k2 */
                plg2.splice((i2 + 1), 0, new marietta.core.Point(ln1.e.x, ln1.e.y, attr));
                i2 += 1;
              }
            } else if (t1 < 1.0) { /* k1-k2 の間にp1を追加し、開口とする。k1 ### p1 --- k2 */
              plg2.splice((i2 + 1), 0, new marietta.core.Point(ln1.s.x, ln1.s.y, flag)); // 非表示区間の始まりを追加 */
              i2 += 1;
              if (t2 >= 1.0) {
                /* 終点まで非表示。k1 ### p1 --- k2 --- p2 */
              } else {
                /* p1-k2 の間にp2を追加し、全面とする。k1 ### p1 --- p2 ### k2 */
                plg2.splice((i2 + 2), 0, new marietta.core.Point(ln1.e.x, ln1.e.y, attr)); // 非表示区間の終わりを追加 */
                i2 += 1;
              }
            }
          } else if (t2 <= 0) { /* p2 --- k1 --- k2 */
            /* 始点から非表示 */
            plg2Arr[i2].flag = flag;
            if (t1 >= 1.0) {
              /* 終点まで非表示 */
            } else {
              plg2.splice((i2 + 1), 0, new marietta.core.Point(ln1.s.x, ln1.s.y, attr));
            }
          } else if (t2 < 1.0) {
            plg2.splice((i2 + 1), 0, new marietta.core.Point(ln1.e.x, ln1.e.y, flag)); /* 非表示区間の始まりを追加 */
            if (t1 >= 1.0) {
              /* 終点まで非表示 */
            } else {
              plg2.splice((i2 + 2), 0, new marietta.core.Point(ln1.s.x, ln1.s.y, attr)); /* 非表示区間の終わりを追加 */
            }
          }
        }
      }
    }
  }

  /*
    * 囲みから線分を作成する
    *
    */
  public PolygonToLine(polyList: marietta3d.AutoGen.utils.RoomPointArray, lineList: marietta3d.AutoGen.utils.RoomPointArray, ksw: boolean): number {
    for (let i = 0; i < polyList.length; i += 1) {
      const ln = polyList.GetLine(i);
      lineList.push(new marietta.core.Point(ln.s.x, ln.s.y, 0));
      lineList.push(new marietta.core.Point(ln.e.x, ln.e.y, 0));
    }
    if (ksw) {
      this.RemovePtInLines(lineList);
    }
    return lineList.length / 2;
  }

  /*
    * RemovePtInLines
    *
    */
  public RemovePtInLines(pLine: marietta3d.AutoGen.utils.RoomPointArray): number {
    for (let i = 0; i < pLine.length; i += 2) {
      const ln1 = pLine.GetLine(i);
      for (let j = 0; j < pLine.length - 1; j += 2) {
        // if (i == j) continue;
        if (i !== j) {
          const ln2 = pLine.GetLine(j);
          // if (this.CheckLineStatus(ln1.s, ln1.e, ln2.s, ln2.e) !== this.RC_CLSTAT.PARALLEL) continue;
          if ((ln1.IsOverlapLine(ln2) <= ZERO_NUM) && (this.CheckLineStatus(ln1.s, ln1.e, ln2.s, ln2.e) === this.RC_CLSTAT.PARALLEL)) {
            const crs = new marietta.core.Point(0, 0, 0);
            // if (!ln1.IntersectionEdge2(ln2, crs)) continue;
            if (ln1.IntersectionEdge2(ln2, crs)) {
              const tmp = new marietta3d.AutoGen.utils.RoomPointArray();
              tmp.AddNew(ln1.s);
              tmp.AddNew(ln1.e);
              tmp.AddNew(ln2.s);
              tmp.AddNew(ln2.e);
              const minp = new marietta.core.Point(0, 0, 0);
              const maxp = new marietta.core.Point(0, 0, 0);
              tmp.GetPolygonMinMax(minp, maxp);
              const angle1 = new marietta.core.Point(ln1.s.x, ln1.s.y, ln1.s.flag).angle(new marietta.core.Point(ln1.e.x, ln1.e.y, ln1.e.flag));
              const angle2 = new marietta.core.Point(minp.x, minp.y, minp.flag).angle(new marietta.core.Point(maxp.x, maxp.y, maxp.flag));
              if (Math.abs(angle1 - angle2) > ZERO_NUM) {
                minp.swap(maxp);
              }
              ln1.s.copyFrom(minp); /* pLine[i]   <-- minp */
              ln1.e.copyFrom(maxp); /* pLine[i+1] <-- maxp */
              pLine.splice(j, 2);
              i = -2;
              break;
            }
          }
        }
      }
    }
    return pLine.length;
  }

    /*
    * ２直線の関係をチェックする
    *
    */
    public RC_CLSTAT = {
      PARALLEL: 1, /* ２直線は平行 */
      VERTICAL: 2, /* ２直線は垂直 */
      DIAGONAL: 3, /* ２直線は斜交 */
      ERROR: 4,
    }

    public CheckLineStatus(l1s: marietta.core.Point, l1e: marietta.core.Point, l2s: marietta.core.Point, l2e: marietta.core.Point): number {
      // 角度や長さに影響されないようベクトルを求めて長さを１にする
      const vec1 = new marietta.core.Point(0, 0, 0);
      const vec2 = new marietta.core.Point(0, 0, 0);

      vec1.x = l1e.x - l1s.x;
      vec1.y = l1e.y - l1s.y;
      vec2.x = l2e.x - l2s.x;
      vec2.y = l2e.y - l2s.y;

      const leng1 = Math.sqrt(vec1.x * vec1.x + vec1.y * vec1.y);
      const leng2 = Math.sqrt(vec2.x * vec2.x + vec2.y * vec2.y);

      // 点を送ってきてもだめ
      if (leng1 < ALMOST_ZERO || leng2 < ALMOST_ZERO) { return this.RC_CLSTAT.ERROR; }

      vec1.scaleDiv(leng1); // これでvec1とvec2の長さは共に１になった
      vec2.scaleDiv(leng2); // 平行なら同一ベクトル(又は正反対方向)になっているはず
      // 垂直なら内積が０になっているはず

      // 平行かどうかチェック
      const sabun = new marietta.core.Point(0, 0, 0);
      sabun.x = vec2.x - vec1.x; // ベクトルが同一方向の場合
      sabun.y = vec2.y - vec1.y;
      const sousatu = new marietta.core.Point(0, 0, 0);
      sousatu.x = vec2.x + vec1.x; // ベクトルが逆方向の場合
      sousatu.y = vec2.y + vec1.y;

      if (Math.sqrt(sabun.x * sabun.x + sabun.y * sabun.y) < ALMOST_ZERO
            || Math.sqrt(sousatu.x * sousatu.x + sousatu.y * sousatu.y) < ALMOST_ZERO) { return this.RC_CLSTAT.PARALLEL; }

      // 垂直かどうかチェック
      const naiseki = vec1.x * vec2.x + vec1.y * vec2.y;

      if ((naiseki < ALMOST_ZERO) && (naiseki > -ALMOST_ZERO)) { return this.RC_CLSTAT.VERTICAL; }

      // 斜交している
      return this.RC_CLSTAT.DIAGONAL;
    }

    /* ##############################################################
    *
    */
    public BuildPolygon(wwline: marietta3d.AutoGen.utils.RoomPointArray, list: Array<marietta3d.AutoGen.utils.RoomPointArray>, ksw: boolean): boolean {
      const line = new marietta3d.AutoGen.utils.RoomPointArray();
      line.CopyFrom(wwline);
      const cr = new marietta.core.Point(0, 0, 0);
      const w = new marietta.core.Point(0, 0, 0);
      const off = 0.001;
      let i: number;
      let j: number;

      /* 重なっている線分を１本にする */
      this.LineFromLines(line);

      /* 交わっている線分を分割する */
      for (i = 0; i < line.length; i += 2) {
        const ln1 = line.GetLine(i);
        for (j = i + 2; j < line.length; j += 2) {
          const ln2 = line.GetLine(j);
          if (ln1.IntersectionEdge2(ln2, cr)) {
            if (cr.distanceTo(ln1.s) > off && cr.distanceTo(ln1.e) > off) {
              w.copyFrom(ln1.e);
              line[i + 1].copyFrom(cr);
              ln1.e = line[i + 1];
              line.Add(new marietta.core.Point(cr.x, cr.y, 0));
              line.Add(new marietta.core.Point(w.x, w.y, 0));
            }
            if (cr.distanceTo(ln2.s) > off && cr.distanceTo(ln2.e) > off) {
              w.copyFrom(ln2.e);
              line[j + 1].copyFrom(cr);
              line.Add(new marietta.core.Point(cr.x, cr.y, 0));
              line.Add(new marietta.core.Point(w.x, w.y, 0));
            }
          }
        }
      }
      /* 囲みに必要ない線分を捨てる */
      for (;;) {
        let sw = false;
        for (i = 0; i < line.length; i += 2) {
          const ln1 = line.GetLine(i);
          let sw1 = false;
          let sw2 = false;
          for (j = 0; j < line.length; j += 2) {
            // if (i == j) continue;
            if (i !== j) {
              const ln2 = line.GetLine(j);
              if (!sw1 && (ln1.s.distanceTo(ln2.s) < off || ln1.s.distanceTo(ln2.e) < off)) sw1 = true;
              if (!sw2 && (ln1.e.distanceTo(ln2.s) < off || ln1.e.distanceTo(ln2.e) < off)) sw2 = true;
              if (sw1 && sw2) break;
            }
          }
          if (!sw1 || !sw2) {
            line.splice(i, 2);
            /* i -= 2; */
            sw = true;
            break;
          }
        }
        if (!sw) {
          break;
        }
      }
      if (line.length < 2) return false;
      /* 線分を反対方向に登録する（線分が二重になる） */
      const cnt = line.length;
      for (i = 0; i < cnt; i += 2) {
        line.AddNew(line[i + 1]);
        line.AddNew(line[i]);
      }

      /* 左回りに線分を追いかけて囲みを作成する */
      for (;;) {
        const pol = new marietta3d.AutoGen.utils.RoomPointArray();
        const ln1 = line.CopyLine(0);
        pol.AddNew(ln1.s);
        line.splice(0, 2);
        let loop = true;
        while (loop) {
          let sa = 2.0 * Math.PI;
          const ka = new marietta.core.Point(ln1.s.x, ln1.s.y, ln1.s.flag).angle(new marietta.core.Point(ln1.e.x, ln1.e.y, ln1.e.flag));
          let no = -1;
          for (i = 0; i < line.length; i += 2) {
            const ln2 = line.GetLine(i);

            // if (ln1.IsOverlapLine(ln2) > off) continue;

            if ((ln1.e.distanceTo(ln2.s) < 1) && (ln1.IsOverlapLine(ln2) <= off)) {
              let ka2 = new marietta.core.Point(ln2.e.x, ln2.e.y, ln2.e.flag).angle(new marietta.core.Point(ln2.s.x, ln2.s.y, ln2.s.flag));
              if (ka2 > ka) ka2 -= 2.0 * Math.PI;
              if ((ka - ka2) < sa) {
                sa = ka - ka2;
                no = i;
              }
            }
          }
          if (no < 0) {
            loop = false;
            break;
          } else {
            pol.Add(new marietta.core.Point(line[no].x, line[no].y, 0));
            if (pol[0].distanceTo(line[no + 1]) < off) {
              /* 左回りの囲みのみを抽出（右回りの囲みは外周になる） */
              if (pol.IsPolygonLeftTurn()) {
                pol.RemovePtInPolygon();/* 途中のポイントを削除 */
                const ary = new marietta3d.AutoGen.utils.RoomPointArray();
                ary.CopyFrom(pol);
                list.push(ary);
              }
              loop = false;
            }
            ln1.CopyPointFrom(line[no], line[no + 1]);
            line.splice(no, 2);
          }
        }
        if (line.length < 4) break;
      }
      /* 囲みの中に出来ている囲みは削除する */
      if (ksw) {
        for (let i2 = 0; i2 < list.length; i2 += 1) {
          const pObj = list[i2];
          let osw = false;
          for (i = 0; i < pObj.length; i += 1) {
            const la = pObj.GetLine(i);
            for (j = 0; j < pObj.length; j += 1) {
              if (i !== j) {
                const lb = pObj.GetLine(j);
                if (la.IsOverlapLine(lb) > 0.0) {
                  osw = true;
                }
              }
            }
          }
          if (osw) {
            const work = new marietta3d.AutoGen.utils.RoomPointArray();
            for (i = 0; i < pObj.length; i += 1) {
              const la = pObj.GetLine(i);
              let ssw = false;
              for (j = 0; j < pObj.length; j += 1) {
                if (i !== j) {
                  const lb = pObj.GetLine(j);
                  if (la.IsOverlapLine(lb) > 0.0) {
                    ssw = true;
                    break;
                  }
                }
              }
              if (!ssw) {
                work.AddNew(la.s);
                work.AddNew(la.e);
              }
            }
            const wlist = [];
            this.BuildPolygon(work, wlist, true);
            for (let i3 = 0; i3 < wlist.length; i3 += 1) {
              const pObj2 = wlist[i3];
              pObj.RemoveAll();
              pObj.CopyFrom(pObj2);
              break;
            }
          }
        }

        for (i = 0; i < list.length; i += 1) {
          const pol = list[i];
          for (j = 0; j < list.length; j += 1) {
            if (i !== j) {
              const pol2 = list[j];
              const wpol = new marietta3d.AutoGen.utils.RoomPointArray();
              pol2.GetOffsetPolygon(wpol, 1, 0);/* チェックを正確に行うため少し縮める */
              if (wpol.IsIncludePolygon(pol) === RC_INCLP.SAME) {
                list.splice(j, 1);
                i = -1;
                break;
              }
            }
          }
        }
      }
      if (list.length === 0) {
        return false;
      }
      return true;
    }

    /* ##############################################################
    *
    */
    public LineFromLines(lin: marietta3d.AutoGen.utils.RoomPointArray): number {
      const wlin = new marietta3d.AutoGen.utils.RoomPointArray();
      const p1 = new marietta.core.Point(0, 0, 0);
      const p2 = new marietta.core.Point(0, 0, 0);
      /* 長さが「１」以上の壁をwlinにコピーする */
      for (let i = 0; i < lin.length; i += 2) {
        lin.CopyPoint(i, p1, p2);
        if (p1.distanceTo(p2) >= 1) { /* 長さが(1)以上のとき wlin に加える */
          wlin.Add(new marietta.core.Point(p1.x, p1.y, 0));
          wlin.Add(new marietta.core.Point(p2.x, p2.y, 0));
        }
      }
      lin.RemoveAll();
      wlin.CopyTo(lin);
      for (let i = 0; i < lin.length; i += 2) {
        const ln1 = lin.GetLine(i);
        for (let j = i + 2; j < lin.length; j += 2) {
          const ln2 = lin.GetLine(j);
          // if (Math.abs(ln1.DistancePtoLine(ln2.s)) > 0.1) continue; /* k1 が(p1-p2)上に無い時 continue */
          // if (this.CheckLineStatus(ln2.s, ln2.e, ln1.s, ln1.e) !== this.RC_CLSTAT.PARALLEL) continue; /* (k1-k2) が(p1-p2)が平行ではない時 continue */
          if ((Math.abs(ln1.DistancePtoLine(ln2.s)) <= 0.1) && (this.CheckLineStatus(ln2.s, ln2.e, ln1.s, ln1.e) === this.RC_CLSTAT.PARALLEL)) {
            /* (p1-p2)上に k1 があり、かつ、(p1-p2)と(k1-k2)が平行のとき */
            const ko = new marietta3d.AutoGen.utils.RoomPointArray();
            ko.AddNew(ln1.s);
            ko.AddNew(ln1.e);
            ko.AddNew(ln2.s);
            ko.AddNew(ln2.e);
            ko.PointSort(p1, p2); /* 4点を(p1->p2)方向でソートする */
            const d1 = ln1.Length() + ln2.Length(); /* (p1-p2)の長さ＋(k1-k2)の長さ */
            const d2 = ko[0].distanceTo(ko[ko.length - 1]); /* ソート後の4点の先頭からお尻までの長さ */
            if (d2 <= d1 + 0.1) {
              /* (p1-p2)と(k1-k2)は重なりがある */
              lin[i].copyFrom(ko[0]); /* p1 <- ko[0] */
              lin[i + 1].copyFrom(ko[ko.length - 1]); /* p2 <- ko[3] */
              lin.splice(j, 2); /* RemoveAt( k1 ), RemoveAt( k2 ) */
              i = -2;
              break;
            }
          }
        }
      }
      return lin.length / 2;
    }

    /* ##############################################################
    * 多角形の結合
    */
    public static MargePolygon(source: Array<marietta3d.AutoGen.utils.RoomPointArray>, result: Array<marietta3d.AutoGen.utils.RoomPointArray>, resultHole: Array<marietta3d.AutoGen.utils.RoomPointArray>) {
      result.splice(0, result.length);
      resultHole.splice(0, resultHole.length);
      const lin = new marietta3d.AutoGen.utils.RoomPointArray();
      for (let loop = 0; loop < source.length; loop += 1) {
        const pol = source[loop];
        pol.RemovePtInPolygon(); /* 領域点の間引き */
        pol.GetPolygonLeftTurn(1);
        for (let j = 0; j < pol.length; j += 1) {
          const p1 = pol[j];
          const p2 = pol[(j + 1) % pol.length];
          const ko = new marietta3d.AutoGen.utils.RoomPointArray();
          Geometry.LineDivideByPolygon(source, loop, p1, p2, ko);
          ko.PointSort(p1, p2);
          /* ko配列の線分が、他の多角形に中点が含まれないときlin配列に登録する */
          for (let k = 0; k < ko.length - 1; k += 1) {
            const k1 = ko[k];
            const k2 = ko[k + 1];
            let sw = false;
            for (let loop2 = 0; loop2 < source.length; loop2 += 1) {
              // if (loop === loop2) { continue; }
              if (loop !== loop2) {
                const pol2 = source[loop2];
                const mid = k1.getMidPoint(k2);
                // if ( pol2.IsInclude( mid ) == utils.RC_INCLUDE.INSIDE ) {
                if (pol2.IsInclude(mid) === 1) {
                  sw = true;
                  break;
                }
              }
            }
            if (!sw) {
              lin.Add(new marietta.core.Point(k1.x, k1.y, 0));
              lin.Add(new marietta.core.Point(k2.x, k2.y, 0));
            }
          }
        }
      }

      let n: number;
      const flg = [];
      for (n = 0; n < lin.length; n += 1) {
        flg.push(0);
      }
      Geometry.MargePlgOverlapLineCheck(lin, flg);
      const wpol = [];
      lin.MakePolygonFromEdge(wpol, flg);
      const gflg = [];
      for (n = 0; n < wpol.length; n += 1) {
        gflg.push(0);
      }
      for (n = 0; n < wpol.length; n += 1) {
        const p1 = wpol[n];
        for (let n2 = n + 1; n2 < wpol.length; n2 += 1) {
          const p2 = wpol[n2];
          const ret = p1.IsIncludePolygon(p2);
          if (ret === RC_INCLP.SAME) gflg[n] = 1;
          if (ret === RC_INCLP.OVERLAP) gflg[n2] = 1;
        }
      }
      for (n = 0; n < wpol.length; n += 1) {
        if (gflg[n] === 0) {
          const plg = new marietta3d.AutoGen.utils.RoomPointArray();
          plg.CopyFrom(wpol[n]);
          result.push(plg);
        } else {
          const plg = new marietta3d.AutoGen.utils.RoomPointArray();
          plg.CopyFrom(wpol[n]);
          resultHole.push(plg);
        }
      }
    }

    /* ##############################################################
    *
    */
    public static LineDivideByPolygon(source: Array<marietta3d.AutoGen.utils.RoomPointArray>, no: number, p1: marietta.core.Point, p2: marietta.core.Point, ko: marietta3d.AutoGen.utils.RoomPointArray) {
      ko.Add(new marietta.core.Point(p1.x, p1.y, 0));
      ko.Add(new marietta.core.Point(p2.x, p2.y, 0));
      const cr = new marietta.core.Point(0, 0, 0);
      const ln1 = new marietta3d.AutoGen.utils.RoomEdge();
      ln1.CopyPointFrom(p1, p2);
      for (let loop = 0; loop < source.length; loop += 1) {
        // if (loop === no) { continue; }
        if (loop !== no) {
          const p = source[loop];
          for (let j = 0; j < p.length; j += 1) {
            const ln2 = p.GetLine(j);
            /* ２つの線分の交点を求める（端点を含む） */
            if (ln1.IntersectionLine(ln2, cr)) {
              if (ln1.DistancePtoEdge(cr) < 1 && ln2.DistancePtoEdge(cr) < 1) {
                /* 求めた交点がko配列に無いとき追加する。 */
                let sw = false;
                for (let k = 0; k < ko.length; k += 1) {
                  if (ko[k].distanceTo(cr) < 1) {
                    sw = true;
                    break;
                  }
                }
                if (sw === false) {
                  ko.Add(new marietta.core.Point(cr.x, cr.y, 0));
                }
              }
            }
          }
        }
      }
    }

    /* ##############################################################
    *
    */
    public static MargePlgOverlapLineCheck(lin: marietta3d.AutoGen.utils.RoomPointArray, flg: Array<number>) {
      let p1: any;
      let p2: any;
      let p3: any;
      let p4: any;
      const flgArr = flg;
      for (let i = 0; i < lin.length; i += 2) {
        // if (flg[i] === 9) continue;
        if (flg[i] !== 9) {
          p1 = lin[i];
          p2 = lin[i + 1];
          for (let j = 0; j < lin.length; j += 2) {
            // if (i === j) continue;
            // if (flg[j] === 9) continue;
            if ((i !== j) && (flg[j] !== 9)) {
              p3 = lin[j];
              p4 = lin[j + 1];
              if (p1.distanceTo(p3) < 1 && p2.distanceTo(p4) < 1) {
                /* (p1-p2)と同じ座標のとき j の側に使用済のマーク */
                flgArr[j] = 9;
              }
              if (p1.distanceTo(p4) < 1 && p2.distanceTo(p3) < 1) {
                /* (p1-p2)と逆の座標のとき i, j の側に使用済のマーク */
                flgArr[i] = 9;
                flgArr[j] = 9;
              }
            }
          }
        }
      }
    }
}
